<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <h3 class="mb-4">
                <strong>{{ $t("InfoGeneral") }}</strong>
              </h3>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider
                  name="Nombre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-input
                    label-placeholder="Nombre"
                    v-model="couponForm.name"
                    class="w-full"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider
                  name="Descripción"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <vs-input
                    label-placeholder="Descripción"
                    v-model="couponForm.description"
                    class="w-full"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <vs-select
                  autocomplete
                  label="Categorías"
                  v-model="couponForm.id_dish_group"
                  class="select w-full"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in dishGroupList"
                  />
                </vs-select>
              </vx-input-group>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <vx-input-group class="mb-2 mt-3">
                <ValidationProvider
                  name="Cantidad a consumir"
                  rules="required|min_value:1"
                  v-slot="{ errors }"
                >
                  <vs-input
                    label-placeholder="Cantidad a consumir"
                    v-model="couponForm.amount"
                    type="number"
                    class="w-full"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <CalendarRangeInput
                v-model="dateRange"
                class="w-full"
                :dateFromCurrent="false"
              ></CalendarRangeInput>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider
                name="Producto Gratis"
                rules="required"
                v-slot="{ errors }"
              >
                <vs-select
                  autocomplete
                  label="Producto Gratis"
                  v-model="couponForm.free_product_id"
                  class="selectDish w-full"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in itemsDishes"
                  />
                </vs-select>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </div>

            <div class="vx-col w-full text-right mt-3">
              <vs-button
                depressed
                color="success"
                type="border"
                class="mr-2"
                @click.prevent="handleSubmit"
              >
                {{ $t("fidelization.CouponEdit") }}
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapActions, mapGetters } from 'vuex';
import CalendarRangeInput from '../components/calendar-range-input/CalendarRangeInput.vue';

export default {
  props: {
    coupon: {
      type: Object,
      required: true,
    },
  },
  components: {
    draggable,
    CalendarRangeInput,
  },
  data() {
    return {
      couponForm: {},
      couponFormOriginal: {},
    };
  },
  created() {
    this.getDishGroups(this.currentRestaurant);
    this.refreshDishes(this.currentRestaurant);
    this.couponForm = this.createCouponData(this.coupon);

    this.couponFormOriginal = JSON.stringify(
      this.createCouponData(this.coupon)
    );
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    ...mapGetters({
      currentRestaurant: 'getCurrentRestaurant',
      dishGroupList: 'getDishGroups',
      itemsDishes: 'getDishes',
      language: 'getCurrentLanguage',
    }),

    dateRange: {
      set (val) {
        this.couponForm.starting_at = val.fromDate;
        this.couponForm.finishing_at = val.toDate;
      },
      get () {
        return {
          fromDate: this.couponForm.starting_at,
          toDate: this.couponForm.finishing_at
        }
      }
    },

    data() {
      const items = this.itemsDishes;
      const results = [];

      items.forEach(function (item, index) {
        const coupon = {
          id: items[index].id,
          name: items[index].name,
          description: items[index].description,
          id_dish_group: items[index].id_dish_group,
          amount: items[index].amount,
          free_product_id: items[index].free_product_id,
          starting_at: items[index].starting_at,
          finishing_at: items[index].finishing_at,
        };

        results.push(coupon);
      }, items);

      return results;
    },
  },
  methods: {
    ...mapActions({
      getDishGroups: 'getDishGroups',
      editCoupon: 'editCoupon',
      refreshCoupons: 'refreshCoupons',
      refreshDishes: 'refreshDishes',
    }),
    handleSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.editCoupon({
          id: this.couponForm.id,
          coupon: formData,
          language: this.language,
        });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    createCouponData(coupon) {
      const auxStartArray = this.coupon.starting_at ? this.coupon.starting_at.split(' ') : undefined;
      const auxFinishArray = this.coupon.finishing_at ? this.coupon.finishing_at.split(' ') : undefined;
      return {
        id: coupon.id,
        name: coupon.name,
        description: coupon.description,
        id_dish_group: coupon.id_dish_group,
        amount: coupon.amount,
        free_product_id: coupon.free_product_id,
        starting_at: auxStartArray ? auxStartArray[0] : undefined,
        finishing_at: auxFinishArray ? auxFinishArray[0] : undefined,
      };
    },

    createFormData() {
      const data = new FormData();
      //const data = this.$refs.images.getFormData();

      data.append('name', this.couponForm.name);
      data.append('description', this.couponForm.description);
      data.append('id_dish_group', this.couponForm.id_dish_group);
      data.append('amount_to_complete', this.couponForm.amount);
      data.append('free_product_id', this.couponForm.free_product_id);
      data.append('starting_at', this.couponForm.starting_at);
      data.append('finishing_at', this.couponForm.finishing_at);
      data.append('restaurant_id', this.currentRestaurant);

      return data;
    },
  },
};
</script>
<style></style>
